import React, { useContext } from 'react';
import { TabsProps, theme as antTheme } from 'antd';

import DevicesContainer, {
  containerConfiguration,
} from '@totem/components/devices/devicesContainer/DevicesContainer';
import DeviceTable from '@totem/components/software/software_package/deviceTable';
import PackageContext from '@totem/components/software/software_package/packageContext';
import PackageVulnerabilities from '@totem/components/software/software_package/packageVulnerabilities';
import VersionDetails from '@totem/components/software/software_package/version/VersionDetails';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import { DEVICES_PAGINATION_ENDPOINT } from '@totem/utilities/endpoints';

const VersionContent = () => {
  const { token } = antTheme.useToken();
  const { data, selectedVersion } = useContext(PackageContext);

  const getVersionTabItems = () => {
    const tabItems: TabsProps['items'] = [
      {
        key: 'details',
        label: 'Details',
        children: <VersionDetails />,
      },
      {
        key: 'vulnerabilities',
        label: 'Vulnerabilities',
        children: <PackageVulnerabilities version={selectedVersion} />,
      },
      {
        key: 'devices',
        label: 'Devices',
        children: (
          <InputContainer
            filterConfig={containerConfiguration}
            defaultSort={{
              field: 'device.displayName',
              direction: 'ascend',
            }}
            componentKey={'software.package.version.devices'}
          >
            <DevicesContainer
              deviceEndPoint={`${DEVICES_PAGINATION_ENDPOINT}/software/${data.package.id}/${selectedVersion}`}
            >
              <DeviceTable />
            </DevicesContainer>
          </InputContainer>
        ),
      },
    ];

    return tabItems;
  };

  return (
    <>
      <IBCard
        title={`Version: ${selectedVersion}`}
        styles={{
          header: {
            backgroundColor: token.Menu.itemColor, // Set your desired background color
          },
        }}
      >
        <IBTabs defaultActiveKey="details" items={getVersionTabItems()} />
      </IBCard>
    </>
  );
};

export default VersionContent;
